import script from "./NumericEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./NumericEditor.vue?vue&type=script&setup=true&lang=js"

import "./NumericEditor.vue?vue&type=style&index=0&id=bd92fa0e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd92fa0e"]])

export default __exports__